import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Base, Button, Flex } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { loginSourceSelector } from '../../redux/core/sourceData/sourceDataSlice.js';
import { useTranslatedSourceOverrideLabel } from '../../helpers/useTranslatedLabel.js';
import { setEmailChangeAlertStatus } from '../Login/loginSlice.js';
import { storageKeys } from '../../configs/constants/storageKeys.js';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { TwoStepConsent } from '../../components/TwoStepConsent/index.js';
import { PasswordlessButton, LoginWithEmailForm, LoginNegativeAlert, } from '../../components/Login/index.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
export const TwoStepLogin = () => {
    const { t } = useTranslation();
    const loginSource = useAppSelector(loginSourceSelector);
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const dispatch = useAppDispatch();
    const headerLabel = useSourceOverrideLabel('twoStepLoginRegistration.login.header');
    const { trackBtnClick, trackModalComponentVisible } = useTrack('twoStep');
    useEffect(() => {
        const isEmailChangeSuccessful = sessionStorage.getItem(storageKeys.isEmailChangeSuccessful) === 'true';
        if (isEmailChangeSuccessful) {
            dispatch(setEmailChangeAlertStatus(isEmailChangeSuccessful));
        }
        trackModalComponentVisible();
    }, []);
    const onShowAllOptions = (e) => {
        trackBtnClick({ uniqueName: 'showAllOptions' });
        e.preventDefault();
        // TODO: replace that with navigateTo
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER));
    };
    return (_jsx(_Fragment, { children: _jsxs(Flex, { flxDirection: "column", gap: "spaceM", "data-testid": "two-step-login-form", children: [_jsx(Base, { mt: ['spaceL', 'spaceNone'], children: _jsx(ContentHeading, { label: headerLabel }) }), _jsx(LoginNegativeAlert, {}), _jsx(LoginWithEmailForm, {}), _jsx(PasswordlessButton, {}), _jsx(Flex, { flxJustify: 'center', children: _jsx(Button, { variant: "link", a11yLabel: t('loginregistration.twoStepLoginRegistration.login.backLink'), "data-testid": "display-socials-button-link", onClick: (e) => onShowAllOptions(e), sx: {
                            fontSize: 'fontSizeM',
                            fontWeight: 'fontWeightNormal',
                        }, children: t('loginregistration.twoStepLoginRegistration.login.backLink') }) }), _jsx(TwoStepConsent, { label: t('loginregistration.twoStepLoginRegistration.login.legalNote'), variant: "login" })] }) }));
};
//# sourceMappingURL=TwoStepLogin.js.map